import { IconGauge, IconHeadphones, IconScale, IconSettings } from '@tabler/icons';

const STATUS_DOTS = {
  alert: { color: 'error.main', label: '채점 기기 경고' },
  stalled: { color: 'orange.dark', label: '채점이 멈춰 있습니다' }
};

const NODES_DOWN_DOT = { color: 'error.main', label: '끊긴 채점 기기가 있습니다' };

export const getGradingMenu = (signal, reviewCount, { operator, nodesDown }) => {
  return {
    id: 'grading-group',
    title: '자동 채점',
    type: 'group',
    children: [
      {
        id: 'grading',
        title: '채점 현황',
        type: 'item',
        url: '/grading',
        icon: IconGauge,
        breadcrumbs: false,
        dot: STATUS_DOTS[signal] ?? null
      },
      {
        id: 'review',
        title: '검토함',
        type: 'item',
        url: '/grading/review',
        icon: IconHeadphones,
        breadcrumbs: false,
        chip: reviewCount > 0 ? { label: reviewCount.toLocaleString('ko-KR'), color: 'primary', variant: 'outlined', size: 'small' } : null
      },
      {
        id: 'trust',
        title: 'AI 신뢰도',
        type: 'item',
        url: '/grading/trust',
        icon: IconScale,
        breadcrumbs: false
      },
      ...(operator
        ? [
            {
              id: 'settings',
              title: '채점 설정',
              type: 'item',
              url: '/grading/settings',
              icon: IconSettings,
              breadcrumbs: false,
              dot: nodesDown ? NODES_DOWN_DOT : null
            }
          ]
        : [])
    ]
  };
};
